@if (value) {
<div
  class="surface-card h-full p-6 flex flex-col group relative overflow-hidden transition-all duration-300 hover:-translate-y-1">
  <div class="absolute inset-0 bg-gradient-to-b from-primary-soft/10 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100"></div>
  <div [ngClass]="[value.gradientClass, 'w-14 h-14 rounded-2xl flex items-center justify-center mb-4 shadow-subtle group-hover:shadow-primary-glow transition-all duration-300 relative z-10']">
    <i [class]="value.icon" class="text-white text-2xl drop-shadow-md"></i>
  </div>
  <h3 class="h3 text-text-primary mb-2 relative z-10 group-hover:text-primary-soft transition-colors duration-300">{{ value.title }}</h3>
  <p class="body-medium text-text-secondary relative z-10">{{ value.description }}</p>
</div>
}